
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2e9ae2c0&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditCategoryTrigger.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditCategoryTrigger.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2e9ae2c0!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditCategoryTrigger.vue"),
  /* scopeId */
  "data-v-2e9ae2c0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/EditCategoryTrigger.vue
// module id = ./dev/src/components/EditCategoryTrigger.vue
// module chunks = 0